import DashboardIcon from '@material-ui/icons/DashboardRounded';
import DashboardList from './Dashboard';

const DashboardModule = {
    icon: DashboardIcon,
    list: DashboardList,
}; export default DashboardModule;